import React, { useState, useRef, useEffect } from "react";
import UploadFile from "components/Common/UploadFile";
// import InstrumentService from "services/Instrument";
import { showToast } from "components/Common";
import DownloadFile from "components/Common/DownloadFile";
import ExportService from "services/ExportS";
import Filter from "./Filter";
import Table from "./Table";
import ImportService from "services/Import";
import ModalInsertUpdateMapInstrumentSurvey from "./ModalIUMapInsSurvey";
import toastr from "toastr";

import { GetListMapInstrumentSurvey } from "../../helpers/app-backend/instrumentsurveybackend_helpers";

const Index = ({ sites }) => {
  const timerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [exportData, setExportData] = useState(null);
  const [detailInstrument, setDetailInstrument] = useState([]);
  const [isShowManualInsertUpdate, setIsShowManualInsertUpdate] =
    useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [error, setError] = useState(null);
  const [paging, setPaging] = useState({
    currentPage: 1,
    pageSize: 100,
  });

  const [dataFilter, setDataFilter] = useState({
    siteName: "",
    instrumentNameSurvey: "",
    mapMasterInstrumentID: "",
  });
  const [dataTable, setDataTable] = useState([]);

  const getDataTable = async (dataFilter, paging) => {
    const commonParams = {
      siteName: dataFilter.siteName?.label,
      instrumentNameSurvey: dataFilter.instrumentNameSurvey,
      mapMasterInstrumentID: dataFilter.mapMasterInstrumentID,
      page: paging.currentPage,
      pageSize: paging.pageSize,
    };
    try {
      const response = await GetListMapInstrumentSurvey(commonParams);
      console.log("response", response);
      if (response.last) {
        setDataTable(response);
        return;
      }
      toastr.error("Đã có lỗi xảy ra");
      setDataTable([]);
    } catch (err) {
      toastr.error("Đã có lỗi xảy ra");
      setDataTable([]);
    }
  };

  useEffect(() => {
    getDataTable(dataFilter, paging);
  }, [paging]);
  return (
    <>
      <Filter
        dataFilter={dataFilter}
        setDataFilter={setDataFilter}
        setIsUpload={setIsUpload}
        getDataTable={getDataTable}
        isLoading={loading}
        error={error}
        setError={setError}
        sites={sites}
        paging={paging}
      />
      <Table
        paging={paging}
        pageSize={paging.pageSize}
        setPaging={setPaging}
        data={dataTable}
        setIsEdit={setIsEdit}
        setDetailInstrument={setDetailInstrument}
        setIsShowModalUpdate={setIsShowManualInsertUpdate}
      />
      {isShowManualInsertUpdate && (
        <ModalInsertUpdateMapInstrumentSurvey
          data={detailInstrument}
          isOpen={isShowManualInsertUpdate}
          onClose={() => setIsShowManualInsertUpdate(false)}
          getDataTable={getDataTable}
          paging={paging}
          dataFilter={dataFilter}
        />
      )}
    </>
  );
};

export default Index;
